import axios from 'axios'
import qs from 'qs';
import { Message } from 'element-ui';
import settings from 'settings';
import { getRequest } from '@/utils/access_token'; // 以前方法 用来获取query 参数
import { TenantInfoFacade } from '@/facade/tenant-info.facade';
const { requestTimeout, contentType, paramsPath, develop } = settings
import store from '@@/store' // 引入store
import { getAccessInstance, get } from '@/utils/access_token';
import { logJson } from '@/utils/ce-track';

let baseURL = window.location.origin 
// 本地启用
if (window.location.hostname == 'localhost') {
  baseURL = develop.host
}

axios.defaults.baseURL = baseURL;
const service = axios.create({
    // baseURL, // 设置基础URL
    timeout: requestTimeout // 设置超时时间
  });
  
  // 请求拦截器
  service.interceptors.request.use(
    config => {
      // 在请求发送之前做些什么
      // 添加公共的请求头、请求参数等
      // 将instance 获取传给url

      config.headers = {
        'X-Requested-With': 'XMLHttpRequest',
        'content-type': settings.contentType[config.dataType || 'json'],
      }
      
      // 一些三方接口不需要token instance tenantid 的特殊处理
      if (config.delPublicParams) {
        return config
      }
      if (!config.params) {
        config.params = {};
      }
      // 没传入的在赋值
      /* if (!config.params['instance']) {
        if (getRequest().instance) {
          config.params['instance'] = getRequest().instance
        } else {
          config.params['instance'] = store.state.numberPortal?.tenantJson?.bossProductInstance
        }
      } */
      config.params['instance'] = (config.params && config.params.instance) || getAccessInstance();

      // 没传入的在赋值
      if (!config.params['tenantId']) {
        config.params['tenantId'] = (config.params && config.params.tenantId) || get(settings.userDataKey) && get(settings.userDataKey).tenantId;//store.state.numberPortal?.tenantJson?.tenantId
      }

     // 针对客户端7天免密处理
      const isInStandaloneMode = () =>
        (window.matchMedia('(display-mode: standalone)').matches) || (window.navigator.standalone) || document.referrer.includes('android-app://');
        if (isInStandaloneMode()) {
          if (localStorage.getItem('TOKEN')) {
            config.params['TOKEN'] = localStorage.getItem('TOKEN');
          }
        } else {
          if (sessionStorage.getItem('TOKEN')) {
            config.params['TOKEN'] = sessionStorage.getItem('TOKEN')
          }
        }


      if (sessionStorage.getItem('wxtoken')){
        config.headers['token'] = sessionStorage.getItem('wxtoken')
      }

      if (config.logFlag) {
        config.headers['optlog'] = logJson(config);
      }
      if (config.dataType == 'form') {
        config.data = qs.stringify(config.data);
      }
      //  || store.state.numberPortal?.token
      return config;
    },
    error => {
      // 对请求错误做些什么
      return Promise.reject(error);
    }
  );
  
  // 响应拦截器
  service.interceptors.response.use(
    response => {
      // 对响应数据做些什么
      // 处理公共的响应数据，如错误处理、数据转换等
      
      if (response.data.status == 999) {
        let locations = decodeURIComponent(response.data.location);
        let connectSymbol = locations.indexOf('?') !== -1 ? '&backurl=' : '?backurl=';
        let href = window.location.href;
        let uri = response.data.location + encodeURIComponent(connectSymbol + encodeURIComponent(href));
        window.location.href = uri;
      } 


      return response.data;
    },
    error => {
      if (error?.name === 'CanceledError') return Promise.reject('接口请求已取消');
      // 对响应错误做些什么
        Message({
            message: '接口异常/请检查参数',
            type: 'error',
        });
      return Promise.reject(error);
    }
  );
  
  export default service;